export const PLAN_TYPE_CHOICES = [
    { id: 0, name: 'FREE' },
    { id: 1, name: 'VIP' },
    { id: 2, name: 'PREMIUM' },
    { id: 3, name: 'TRAIL' },
];

export const SUBSCRIPTION_STATUS_CHOICES = [
    { id: 9, name: 'ACTIVE' },
    { id: 1, name: 'PAUSED' },
    { id: 2, name: 'EXPIRED' },
];

export const PLAN_TYPE_MAP: { [key: number]: { label: string; color: string } } = {
    0: { label: 'FREE', color: '#546e7a' },
    1: { label: 'VIP', color: '#2e7d32' },
    2: { label: 'PREMIUM', color: '#1565c0' },
    3: { label: 'TRAIL', color: '#6a1b9a' },
};

export const SUBSCRIPTION_STATUS_MAP: { [key: number]: { label: string; color: string } } = {
    9: { label: 'ACTIVE', color: '#2e7d32' },
    1: { label: 'PAUSED', color: '#ef6c00' },
    2: { label: 'EXPIRED', color: '#c62828' },
};
